const pad2 = (n: number) => String(n).padStart(2, '0');
export const toYearMonthString = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
export const toYearMonthDayString = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-01`;
export const addDayToYearMonthString = (yearMonthString: string) => {
  return yearMonthString + '-01';
};

export interface IMonthRange {
  monthFrom: string;
  monthTo: string;
}

export const getDefaultMonthRange = (): IMonthRange => {
  const now = new Date();
  const monthTo = toYearMonthDayString(now);
  const monthFrom = toYearMonthDayString(new Date(now.getFullYear(), now.getMonth() - 11, 1));
  return { monthFrom, monthTo };
};

export interface IYearMonth {
  year: number;
  month: number;
}

/** Parse a YYYY-MM-DD date string into separate year and month integers. */
export const dateToYearMonth = (date: string): IYearMonth => {
  const [year, month] = date.split('-').map(Number);
  return { year, month };
};
